<template>
  <footer class="footer">
    <div class="footer__wrap row-1">
      <div class="section certificates">
        <div class="certificates-container">
          <div
            class="certificate"
            v-for="(certificate, index) in footer.globalSets[2].certificate"
            :key="index"
          >
            <img
              :src="certificate.icon[0].url"
              :alt="certificate.icon[0].title"
              class="certificate-image"
              :class="getLowercaseClass(certificate.icon[0].title)"
              loading="lazy"
            />
            <div class="certificate-link show-for-large">
              <a
                v-for="(link, index) in certificate.certificateLinks"
                :key="index"
                class="certificate-link-item"
                :href="link.file[0].url"
                target="_blank"
              >
                <img
                  src="@/assets/img/ico/download-icon.svg?url"
                  alt="Download Icon"
                />
                <div class="reverse-underline-hover text">
                  <span class="text-small">{{ link.title }}</span>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="mobile-links-list hide-for-large">
          <div
            v-for="(certificate, certificateIndex) in footer.globalSets[2]
              .certificate"
            :key="certificateIndex"
            class="link"
          >
            <a
              v-for="(link, index) in certificate.certificateLinks"
              :key="index"
              :href="link.file[0].url"
              class="item"
              target="_blank"
            >
              <div class="reverse-underline-hover">
                <span class="text-base">{{ link.title }}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <!--<div class="section newsletter">
        <div class="text">
          <h4 class="title-large2 is-light">
            Iscriviti alla nostra newsletter
          </h4>
        </div>
        <div class="icon-container">
          <div class="icon">
            <IconNl class="icon" alt="Icon" />
          </div>
          <div class="icon-hover">
            <IconNl class="icon-hover" alt="Hover Icon" />
          </div>
        </div>
      </div>-->
      <div class="section menu">
        <div class="left-column">
          <div class="sub-column1 show-for-large">
            <div>
              <ul class="links-desk">
                <li v-for="link in linksMain" :key="link.key">
                  <NuxtLink
                    v-if="link.route"
                    :to="localePath(link.route)"
                    class="simple-underline-hover"
                  >
                    <span class="title-base">{{
                      link.title ? link.title : $t('navigation.' + link.key)
                    }}</span>
                  </NuxtLink>
                </li>
              </ul>
            </div>
            <div>
              <FooterLangSwitch />
            </div>
          </div>
          <div class="sub-column2 show-for-large">
            <ul class="links-desk">
              <li v-for="link in linksSecondary" :key="link.key">
                <NuxtLink
                  v-if="link.route"
                  :to="localePath(link.route)"
                  class="simple-underline-hover"
                >
                  <span class="text-base">{{
                    link.title ? link.title : $t('navigation.' + link.key)
                  }}</span>
                </NuxtLink>
                <template v-else>
                  <NuxtLink
                    v-if="link.route"
                    :to="localePath(link.route)"
                    class="simple-underline-hover"
                  >
                    <span class="text-base">{{
                      link.title ? link.title : $t('navigation.' + link.key)
                    }}</span>
                  </NuxtLink>
                </template>
              </li>
            </ul>
          </div>
          <div class="mobile-list hide-for-large">
            <ul>
              <!--<li
                v-for="link in linksMain.filter(
                  (link) => link.key === 'accountArea',
                )"
                :key="link.key"
              >
                <NuxtLink v-if="link.route" :to="localePath(link.route)">
                  <span class="text-medium">{{
                    link.title ? link.title : $t('navigation.' + link.key)
                  }}</span>
                </NuxtLink>
              </li>-->
              <li v-for="link in linksSecondary" :key="link.key">
                <template v-if="link.route && link.route.url">
                  <a :href="link.route.url">
                    <span class="text-medium">{{
                      link.title ? link.title : $t('navigation.' + link.key)
                    }}</span>
                  </a>
                </template>
                <template v-else>
                  <NuxtLink :to="localePath(link.route)">
                    <span class="text-medium">{{
                      link.title ? link.title : $t('navigation.' + link.key)
                    }}</span>
                  </NuxtLink>
                </template>
              </li>
            </ul>
            <div class="mobile-lang-switch-section">
              <FooterLangSwitch />
            </div>
          </div>
        </div>
        <div class="right-column">
          <NuxtLink :to="localePath({ name: 'index' })" class="footer-logo">
            <Logo
              class="logo"
              width="200"
              height="70"
              :filled="true"
              :alt="runtimeConfig.public.siteName"
            />
          </NuxtLink>
        </div>
      </div>
      <div class="section bottom-info text-small">
        <p class="show-for-large">© {{ currentYear }} Bioenologia 2.0</p>
        <p class="show-for-large">
          Bioenologia 2.0 S.r.l. - Via Verdi, 32 31046 Oderzo - TV ITALIA -
          P.iva IT04024020267
        </p>
        <p class="hide-for-large">
          Bioenologia 2.0 S.r.l.<br />
          Via Verdi, 32 31046 Oderzo - TV ITALIA<br />
          P.iva IT04024020267
        </p>
        <div class="simple-underline-hover">
          <a href="https://www.quamm.it/" target="_blank">Quamm</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useStore } from '@/store/index.js'
import queries from '@/graphql/craft/queries/index.js'
import { navMenu } from '@/bucket/navigation.js'
import Logo from '@/assets/img/logo-bioenologia-white.svg'
// import IconNl from '@/assets/img/ico/arrow-down-white.svg'

const { configuration } = useStore()

const query = queries.footer.getFooter

const variables = computed(() => ({
  site: configuration.site,
}))

const { data } = await useGraphql(query, variables)

if (!data.value) {
  throw createError({ statusCode: 404 })
}

const footer = computed(() => data.value)

const getLowercaseClass = (title) => {
  return title.toLowerCase()
}

const runtimeConfig = useRuntimeConfig()
const currentYear = ref(new Date().getFullYear())

const linksMain = navMenu.linksMain
const linksSecondary = navMenu.linksSecondary
</script>

<script>
export default {
  name: 'Footer',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
